import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';
import { useTranslate } from '@front-app/hooks/useTranslate';
import { GroupMember } from '@front-app/services/UserApi/UserModel';
import { EnumMap } from '@front-app/util/enum';
import { FontAwesomeIconProps, SORT_BY_ALPH_ASC_ICON, SORT_BY_DATE_ICON } from '@front-app/vendor/icon-definitions';
import { computed, Ref, SetupContext } from '@vue/composition-api';
import { sortGroupMemberByJoinDate, sortGroupMemberByName } from '../util/sort';

export enum MemberSort {
	// NOTE: These strings are used to make API requests
	ALPHABETICAL = 'alphabetical_asc',
	LAST_JOIN = 'date_joined_desc',
}

export const SORT_TO_SORTER: EnumMap<MemberSort, (a: GroupMember, b: GroupMember) => number> = {
	[MemberSort.ALPHABETICAL]: sortGroupMemberByName,
	[MemberSort.LAST_JOIN]: sortGroupMemberByJoinDate,
};

export const SORT_TO_ICON: EnumMap<MemberSort, FontAwesomeIconProps> = {
	[MemberSort.ALPHABETICAL]: SORT_BY_ALPH_ASC_ICON,
	[MemberSort.LAST_JOIN]: SORT_BY_DATE_ICON,
};

export const ORDERED_SORT_OPTIONS = [
	MemberSort.ALPHABETICAL,
	MemberSort.LAST_JOIN,
];

export const sortButtonLabels: EnumMap<MemberSort, string> = {
	[MemberSort.LAST_JOIN]: 'group-members.sort.last-joined',
	[MemberSort.ALPHABETICAL]: 'group-members.sort.alphabetical',
};

export interface RadioComponentState {
	selectedChoice: MemberSort;
	choices: SelectBoxChoice[];
	icons: EnumMap<MemberSort, FontAwesomeIconProps>;
	hasIcons: boolean;
}

export interface UseSortMemberRadio {
	sort: (a: GroupMember, b: GroupMember) => number;
	sortRadioState: Ref<RadioComponentState>;
}

export const useSortMemberRadio = (ctx: SetupContext, selectedChoice: Ref<MemberSort>): UseSortMemberRadio => {
	const t = useTranslate(ctx);
	const getChoices = () => ORDERED_SORT_OPTIONS
		.map((key) => ({
			key,
			label: t(sortButtonLabels[key]) as unknown as string,
		}));
	const state = computed(() => ({
		selectedChoice: selectedChoice.value,
		choices: getChoices(),
		icons: SORT_TO_ICON,
		hasIcons: true,
	}));
	const sort = (a: GroupMember, b: GroupMember) => SORT_TO_SORTER[selectedChoice.value](a, b);
	return {
		sortRadioState: state,
		sort,
	};
};
